import React from 'react';
import { Paper, Typography, Box } from '@material-ui/core';

export const ScaleResultVGI = ({
    title = 'Resultados',
    message = 'Esta escala no tiene informe disponible.',
    hint = 'Revise los datos de la escala o contacte al administrador si necesita un reporte.',
}) => {
    return (
        <Paper elevation={0} style={{ padding: 24, borderRadius: 12 }}>
            <Typography variant="h5" style={{ fontWeight: 700, marginBottom: 12, color: '#0d1b2a' }}>
                {title}
            </Typography>
            <Typography variant="subtitle1" style={{ color: '#0d1b2a', marginBottom: 8 }}>
                {message}
            </Typography>
            {hint && (
                <Box mt={1}>
                    <Typography variant="body2" style={{ color: '#5f6b7a' }}>
                        {hint}
                    </Typography>
                </Box>
            )}
        </Paper>
    );
};

export default ScaleResultVGI;
